// The Pitch Match colours (issue #3518), from the two "Pitch Match, staff version" artboards. The
// app's accent purple (--color-tab-selected) carries the target, the guide line and the space
// letters, and the staff's own greys come from --color-text and --color-text-darker, so those are
// variables and flip with the theme. The colours below are the ones whose meaning is the colour -
// searching, locked, and the two hint colours - so they are fixed hex like the Rhythm result
// colours in learn_colors.ts and stay themselves in dark mode.

// The singer's dot, and the hold meter's fill, take the same two colours
export type PitchDotColor = 'yellow' | 'green';

export const pitchSearchingYellow = '#f5b800'; // the dot while the singer is still searching
export const pitchLockedGreen = '#3a9a00'; // the dot in tolerance, and the note and guide line on a lock

export const pitchDotColorCss: Record<PitchDotColor, string> = {
  yellow: pitchSearchingYellow,
  green: pitchLockedGreen,
};

// The hold meter fills in the same yellow while they search and green once they are on the note
export const pitchHoldFillCss: Record<PitchDotColor, string> = pitchDotColorCss;

// The hint above the meter: amber for "a little higher" and "a little lower", green for "Hold it!".
// Both are darker than the dot's colours because they are text at 24 px on the page's background.
export const pitchHintAmber = '#b07a00';
export const pitchHintGreen = '#2f8a00';
